import * as React   from "react";
import {cx} from 'emotion';
import { Template } from "../../common/template/template";
import "./templates-grid.scss";
import { useEffect, useState } from "react";
import { parseUrlQuery } from "@Common/utils/parse-url-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

export const TemplatesGrid = ({ categories, currentPage, setCurrentPage, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels }) => {
    const urlParams = parseUrlQuery(window.location.search) || {q:""};
    const [itemsPerPage, setItemsPerPage] = useState(50);
    const nonCustomTemplates = Array.from(
        new Map(categories.flat().filter(t => t.relation_type != "custom").map(template => [template.template_id, template])).values()
    );

    const flattenedCategories = [
        ...Array.from(nonCustomTemplates.values()),
        ...categories.flat().filter(t => t.relation_type === "custom")
    ]
    const finalCategories = filterCategories({urlParams, flattenedCategories})
    const totalPages = Math.ceil(finalCategories.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedCategories = finalCategories.slice(startIndex, startIndex + itemsPerPage);

    const changePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="tmpg-w0w1">
            <div className="results-container">
                {ResultsInfo({
                    totalResults: finalCategories.length,
                    itemsPerPage,
                    setItemsPerPage,
                    setCurrentPage
                })}
            </div>
            <div className="templates-grid">
                {paginatedCategories.map((item, i) => (
                    <Template key={i} {...{item, userLevels, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal}}/>
                ))}
            </div>
            <div className="page-select-container">
                {totalPages > 1 && PageNumbers({currentPage, totalPages, changePage})}
            </div>
        </div>
    );
};

const filterCategories = ({ urlParams, flattenedCategories }) => {
    const categoryCounts = flattenedCategories.reduce((acc, category) => {
        const productFamily = category.product_family_name || "Other";
        category.product_family_name = productFamily;

        acc[productFamily] = (acc[productFamily] || 0) + 1;
        return acc;
    }, {});

    const sortedCategories = [...flattenedCategories].sort((a, b) =>
        categoryCounts[b.product_family_name] - categoryCounts[a.product_family_name]
    );

    if (urlParams.q && !urlParams.products && !urlParams.categories) {
        return sortedCategories;
    }

    const selectedProducts = urlParams.products ? urlParams.products.split("~") : [];
    const selectedCategories = urlParams.categories ? urlParams.categories.split("~") : [];

    return sortedCategories.filter(category => {
        const isProductMatch = selectedProducts.length > 0 ? selectedProducts.includes(category.product_family_name) : true;
        const isCategoryMatch = selectedCategories.length > 0 ? selectedCategories.includes(category.category_name) : true;

        return isProductMatch && isCategoryMatch;
    });
};



const ResultsInfo = ({ totalResults, itemsPerPage, setItemsPerPage, setCurrentPage }) => {
    return (
        <div className="results-info">
            <span className="bold-header">{totalResults} RESULTS</span>
            <span className="base-75">Results per Page</span>
            <select
                className="select-pages"
                value={itemsPerPage}
                onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                }}
            >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
            </select>
        </div>
    );
};

const PageNumbers = ({ currentPage, totalPages, changePage }) => {
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            changePage(page);
        }
    };

    const generatePageNumbers = () => {
        const pageNumbers = [];
        let startPage = currentPage - 2;
        let endPage = currentPage + 2;

        if (startPage < 1) {
            startPage = 1;
            endPage = Math.min(5, totalPages);
        }
        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - 4);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <div className="page-numbers">
            <div className={cx("back-section", {hidden: currentPage <= 1})}>
                <div className="color-button" onClick={() => handlePageChange(1)}>
                    <FontAwesomeIcon icon={faAngleDoubleLeft} />
                </div>
                <div className="color-button" onClick={() => handlePageChange(currentPage - 1)}>Back</div>
            </div>
            <div className="numbers-section">
                {generatePageNumbers().map((pageNum) => (
                    <div
                        key={pageNum}
                        onClick={() => handlePageChange(pageNum)}
                        className={cx("page-button", {active: currentPage === pageNum})}
                    >
                        {pageNum}
                    </div>
                ))}
            </div>
            <div className={cx("next-section", {hidden: currentPage >= totalPages})}>
                <div className="color-button" onClick={() => handlePageChange(currentPage + 1)}>Next</div>
                <div className="color-button" onClick={() => handlePageChange(totalPages)}>
                    <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div>
            </div>
        </div>
    );
};

